export enum EOrderHistoryType {
  Accepted = 'accepted',
  Refused = 'refused',
  Viewed = 'viewed',
  RefusedAfterAccepted = 'refused_after_accepted',
  AcceptedAfterRefused = 'accepted_after_refused',
  Ignored = 'ignored',
}

export const orderHistoryTypeLabels = {
  [EOrderHistoryType.Accepted]: 'Aceito',
  [EOrderHistoryType.AcceptedAfterRefused]: 'Aceito',
  [EOrderHistoryType.Refused]: 'Recusado',
  [EOrderHistoryType.Ignored]: 'Ignorado',
  [EOrderHistoryType.Viewed]: 'Ignorado',
  [EOrderHistoryType.RefusedAfterAccepted]: 'Recusado após aceitar',
}
